<template>
  <div class="d-flex" id="wrapper" v-bind:class="{ toggled: showMenu }">
    <SideNavigation></SideNavigation>
    <div id="page-content-wrapper">
      <TopNavigation v-on:togglemenuview="handleToggleMenu"></TopNavigation>
      <div class="container-fluid content">
        <div class="row">
          <div class="col-md-5">
            <form  @submit="addDomain" method="post">
              <div class="row">
                <div v-if="output" class="col-md-12">
                  <div class="alert" :class="success ? 'alert-success' : 'alert-warning'" role="alert">{{ output }}</div>
                </div>
                <div class="col-md-8">
                  <input type="domain" name="name" class="form-control" v-model="formFields.name" placeholder="Domain name" required />
                </div>
                <div class="col-md-4">
                  <button type="submit" class="btn btn-primary" >Add</button>
                </div>
              </div>
            </form>
          </div>
          <div class="col-md-7">
            <table class="table">
              <tbody>
                <tr>
                  <th>S/N</th>
                  <th>Name</th>
                  <th></th>
                  <th></th>
                </tr>
                <tr v-for="(row, index) in result" v-bind:key="row.id" class="a">
                  <td @click="details(row)">{{ index+1 }}</td>
                  <td @click="details(row)"> {{ row.name }}</td>
                  <td @click="details(row)">{{ row.status == "A" ? 'Inactive: verification required' : 'Active' }}  </td>
                  <td @click="remove(row.name, row.id, index)" class="a"><img class="icon" src="@/assets/svg/x-circle.svg" alt="Delete" /> </td>
                </tr>
              </tbody>
            </table>

            <div class="cpager"><ul  @click="getPage" v-html="pager"></ul></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <DomainDetails v-if="showDetails" @close="showDetails = false" :payload="payLoad"></DomainDetails>
</template>

<script>
import { backendUrl } from '@/config';
import axios from 'axios'
import SideNavigation from '@/components/SideNavigation.vue'
import TopNavigation from '@/components/TopNavigation.vue'
import DomainDetails from '@/views/modal/DomainDetails.vue'

export default {
  name: 'Domain',
   components: {
    SideNavigation,
    TopNavigation,
    DomainDetails
  },
  data () {
    return {
      showMenu: false,
      showDetails: false,
      loading: false,
      success: false,
      payLoad:{},
      output:null,
      result: null,
      pager: null,
      formFields: {
        name: "",
        user_id: this.$store.state.user.id
      }
    }
  },
  mounted () {
    let obj = this
    obj.loading = true
    axios
      .get(backendUrl+'domain', {
        params: {
          page: 1,
          size: 10,
          user_id: this.$store.state.user.id
        }
      })
      .then(response => {
        //alert(response.data)
        //console.log(response.data.result.rows)
        obj.result = response.data.result.rows
        obj.pager = response.data.result.pagenation
      })
      .catch(error => {
        alert(error.message)
      })
      .finally(() => obj.loading = false)
  },
  methods : {
    handleToggleMenu(menuState) {
      this.showMenu = menuState
    },
    details(payload){
      //alert(item.id)
      console.log(payload)
      this.payLoad = payload
      this.showDetails = true
    },
    remove(name, id, index){
      if(!confirm("Are you sure, you want to delete "+ name)){
        return
      }
     
      let obj = this
        obj.loading = true
        axios
          .get(backendUrl+'remove', {
            params: {
              type: "domains",
              user_id: this.$store.state.user.id,
              id:id 
            }
          })
          .then(response => {
            alert(response.data.message)
            obj.result.splice(index, 1)
            //obj.result = response.data.result.rows
            //obj.pager = response.data.result.pagenation
          })
          .catch(error => {
            alert(error.message)
          })
          .finally(() => obj.loading = false)
    },
    getPage(e) {
      if(e.target.getAttribute("data") != null){
        let obj = this
        obj.loading = true
        axios
          .get(backendUrl+'domain', {
            params: {
              page: e.target.getAttribute("data"),
              size: 10
            }
          })
          .then(response => {
            obj.result = response.data.result.rows
            obj.pager = response.data.result.pagenation
          })
          .catch(error => {
            alert(error.message)
          })
          .finally(() => obj.loading = false)
      }
    },
    addDomain(e) {
      let obj = this
      obj.loading = true
      obj.output = null
      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
      }

      axios({
          method: 'post',
          url: backendUrl+'domain',
          params: this.formFields,
          headers: headers
      })
      .then(function (response) {
        if(response.data.success == 1){
          obj.formFields.name = ''
          obj.success = true;
        } else {
          obj.success = false
        }
        obj.output = response.data.message
        obj.result = response.data.result.rows
        obj.pager = response.data.result.pagenation
        obj.loading = false
        console.log(response);
      })
      .catch(function (error) {
          console.log(error);
      });
      e.preventDefault()
    }
  }
}
</script>
